export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./pdf-viewer.vue?vue&type=template&id=236a4bde&"


//////////////////
// WEBPACK FOOTER
// ./src/components/pdf-viewer/pdf-viewer.vue?vue&type=template&id=236a4bde&
// module id = 275
// module chunks = 1